export const URL_GET_CATEGORY_LIST = '/v1/gocheckin/category/site/list?';
export const URL_GET_SERVICE_LIST_BY_CATEGORY = '/v1/gocheckin/category/site/get-service-by-category?';
export const URL_ADD_CATEGORY = '/v1/gocheckin/category/form/create';
export const URL_UPDATE_CATEGORY = '/v1/gocheckin/category/form/update?';
export const URL_DELETE_CATEGORY = '/v1/gocheckin/category/form/delete?';
export const URL_ADD_SERVICE = '/v1/gocheckin/service/form/create';
export const URL_UPDATE_SERVICE = '/v1/gocheckin/service/form/update?';
export const URL_DELETE_SERVICE = '/v1/gocheckin/service/form/delete?';
export const URL_MOVE_CATEGORY = '/v1/gocheckin/category/form/move';
export const URL_GET_SERVICE_LIST = '/v1/gocheckin/service/site/list?';
export const URL_GET_SERVICE_INFO = '/v1/gocheckin/service/site/info?';
export const URL_DRAG_CATEGORY = '/v1/gocheckin/category/form/sort-category';
export const URL_IMPORT_SERVICE = '/v1/gocheckin/import/form/upload';
export const URL_DRAG_SERVICE = '/v1/gocheckin/service/form/sort';

//POS
export const URL_GET_ALL_CATEGORY_LIST = '/v1/gocheckin/category/site/list-all?';
export const URL_DRAG_PRODUCT = '/v1/pos/product/form/sort'

export const URL_GET_CATEGORY_LIST_BY_TYPE = "/v1/gocheckin/category/site/list?";
// export const URL_ADD_CATEGORY_POS = "/v1/gocheckin/category/form/create";
// export const URL_UPDATE_CATEGORY_POS = "/v1/gocheckin/category/form/update?";
// export const URL_DELETE_CATEGORY_POS = "/v1/gocheckin/category/form/delete?";
export const URL_GET_PRODUCT_LIST_POS = "/v1/pos/product/site/list?";
export const URL_ADD_PRODUCT_POS = "/v1/pos/product/form/create";
export const URL_UPDATE_PRODUCT_POS = "/v1/pos/product/form/update";
export const URL_DELETE_PRODUCT_POS = "/v1/pos/product/form/delete?";
export const URL_GET_SERVICE_LIST_POS = "/v1/gocheckin/service/site/list?";
export const URL_ADD_SERVICE_POS = "/v1/gocheckin/service/form/create";
export const URL_UPDATE_SERVICE_POS = "/v1/gocheckin/service/form/update?";
export const URL_DELETE_SERVICE_POS = "/v1/gocheckin/service/form/delete?";
export const URL_GET_COMBO_LIST_POS = "/v1/pos/combo/site/list?";
export const URL_ADD_COMBO_POS = "/v1/pos/combo/form/create";
export const URL_UPDATE_COMBO_POS = "/v1/pos/combo/form/update";
export const URL_DELETE_COMBO_POS = "/v1/pos/combo/form/update-status";

export const URL_GET_GIFTCARD_LIST = "/v1/pos/giftcard/site/list?";
export const URL_GET_GIFTCARD_DETAIL = "/v1/pos/giftcard/site/detail?";
export const URL_DOWNLOAD_GIFTCARD_TEMPLATE = "v1/pos/giftcard/form/file-import";
export const URL_EXPORT_GIFTCARD = "/v1/pos/giftcard/form/export?";
export const URL_IMPORT_GIFTCARD = "/v1/pos/giftcard/form/import";
export const URL_CREATE_GIFTCARD = "/v1/pos/giftcard/form/create";
export const URL_MULTI_CREATE_GIFTCARD = "v1/pos/giftcard/form/multi-create";

export const URL_GET_COMBO_LIST_ACTIVE = "/v1/pos/combo/site/list?";

export const URL_GET_FULL_CATEGORY_SERVICE_LIST = "/v1/pos/category/site/list-item";